module.exports = __webpack_public_path__ + "static/team-9a84e65e78221b7e8304910f2f03ec46.jpg";